var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.now && _vm.end && !_vm.finished)?_c('h1',{attrs:{"id":"clock"}},[_c('time',[_vm._v(_vm._s(_vm.display))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }